export  const NEWS=[
    {
        date: 'Oct 2021',
        content: 'Congratulations to Manoranjan Bera for successfully defended his synopsis for Ph.D thesis.',
        img :require('../images/manoranjan.jpg')
    },
    {
        date: 'Oct 2021',
        content: 'Congratulations to Biswajit Roy for successfully defended his Ph.D thesis and was awarded the Ph.D degree.',
        img :require('../images/Biswajit photo.jpg')
    },
    {
        date: 'Sep 2021',
        content: 'Congratulations to Amrita Chaudhuri for Successfully defended her Ph.D thesis and was awarded the Ph.D degree.',
        img :require('../images/ac p0t0.jpg')
    }
    
];